import React from 'react';
import {IElementLikertScale} from '../../../../incase-domain/elements/question/likertScale';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';

function LikertScaleQuestions(props: IQuestionElementProps<IElementLikertScale>): JSX.Element {
    const {device, element} = props;

    if (device === DeviceType.MOBILE) {
        return (
            <div className="c-likertScale c-likertScale--mobile">
                {element.questions.map((question) => (
                    <div key={question.id} className="u-mt-2">
                        <div
                            className="c-likertScale__question"
                            style={{
                                fontFamily: element.fontFamily?.name,
                            }}
                        >
                            {question.text}
                        </div>
                        <div className="c-likertScale__scale u-mt-1">
                            {element.scale.map((scale) => (
                                <div key={scale.id} className="c-likertScale__scale_scaleRow">
                                    <span
                                        style={{
                                            fontFamily: element.fontFamily?.name,
                                        }}
                                    >
                                        {scale.text}
                                    </span>
                                    <input type="radio" name={`question-${question.id}`} key={`${question.id}-${scale.id}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="c-likertScale c-likertScale__gridContainer">
            {element.scale.map((scale, index) => (
                <div
                    key={scale.id}
                    style={{
                        gridRow: 1,
                        gridColumn: index + 2,
                        fontSize: `${element.fontSize || 'initial'}em`,
                        fontFamily: element.fontFamily?.name,
                    }}
                    className="c-likertScale__scaleText"
                >
                    {scale.text}
                </div>
            ))}

            {element.questions.map((question, index) => (
                <div
                    key={question.id}
                    style={{
                        gridRow: index + 2,
                        gridColumn: 1,
                        fontSize: `${element.fontSize || 'initial'}em`,
                        fontFamily: element.fontFamily?.name,
                    }}
                    className="c-likertScale__question u-mt-1"
                >
                    {question.text}
                </div>
            ))}

            {element.questions.map((question, i) =>
                element.scale.map((scale, j) => (
                    <input
                        type="radio"
                        name={`question-${question.id}`}
                        value={scale.id}
                        disabled
                        style={{gridRow: i + 2, gridColumn: j + 2}}
                        key={question.id + scale.id}
                    />
                ))
            )}
        </div>
    );
}

export default LikertScaleQuestions;
